/**
 * 文档地址：https://www.npmjs.com/package/axios
 */
import axios from "axios";
import { Message } from "element-ui";
import store from "@/store/index";

/**
 * 创建axios实例
 */
const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: "/",
  timeout: 35000,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

/**
 * 全局处理返回response对象
 */
axiosInstance.interceptors.response.use(
  ({ data }) => {
    if (data.code == 401) {
      window.location.href = "";
    } else if (data.code == 500 || data.code == 502) {
      Message({
        message: "服务器错误" + data.code,
        type: "error",
        duration: 3 * 1000,
      });
      // return data;
    } else {
      return data;
    }
  },
  (error) => {
    if (error.response && error.response.status == 401) {
      // console.log(store.state.system.logSSOUrl);
      window.location.href = store.state.system.logSSOUrl;
    }
    return Promise.reject(error);
  }
);

/**
 * 发起post请求
 * @param {*} url 请求地址
 * @param {*} data 传递参数，json格式
 * @returns promise
 */
const post = function (...rest) {
  // 由于运营获取不到shopId，所以这里要在headers里加上shopId
  if (rest.length === 1) {
    rest[1] = {};
    rest[2] = {
      headers: {
        "shop-id": store.state.user.userInfo.shopId,
      },
    };
  } else if (rest.length === 2) {
    rest[2] = {
      headers: {
        "shop-id": store.state.user.userInfo.shopId,
      },
    };
  } else {
    rest[2].headers = {
      "shop-id": store.state.user.userInfo.shopId,
    };
  }
  return axiosInstance.post(...rest);
};

/**
 * 发起get请求
 * @param {*} url 请求地址
 * @param {*} params 请求参数，json格式
 * @returns
 */
const get = function (url, params = {}, config = {}) {
  //每个入参后边加上时间戳，解决IE9对接口缓存问题
  params = Object.assign(params, { _t: new Date().getTime() });
  // 由于运营获取不到shopId，所以这里要在headers里加上shopId
  config.headers = {
    "shop-id": store.state.user.userInfo.shopId,
  };
  return axiosInstance.get(url, { params, ...config });
};

/**
 * 发起delete请求
 * @param {*} url 请求地址
 * @param {*} params 请求参数
 * @returns promise
 */
const del = function (url, params) {
  return axiosInstance.delete(url, { params });
};

/**
 * 发起put请求
 * @param {*} url 请求地址
 * @param {*} data 请求数据
 * @returns promise
 */
function put(url, data) {
  return axiosInstance.put(url, data);
}

export default {
  get,
  post,
  del,
  put,
};
